export const TrelloMarkInverse = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M36.429 7.69385H11.571C9.42997 7.69385 7.69397 9.42985 7.69397 11.5708V36.4288C7.69397 38.5698 9.42997 40.3058 11.571 40.3058H36.429C38.57 40.3058 40.306 38.5698 40.306 36.4288V11.5708C40.306 9.42985 38.57 7.69385 36.429 7.69385ZM21.742 31.1828C21.742 31.8948 21.165 32.4708 20.454 32.4708H15.003C14.291 32.4708 13.715 31.8938 13.715 31.1828V15.0028C13.715 14.2908 14.292 13.7148 15.003 13.7148H20.454C21.166 13.7148 21.742 14.2918 21.742 15.0028V31.1828ZM34.285 23.7548C34.285 24.4668 33.708 25.0428 32.997 25.0428H27.546C26.834 25.0428 26.258 24.4658 26.258 23.7548V15.0028C26.258 14.2908 26.835 13.7148 27.546 13.7148H32.997C33.709 13.7148 34.285 14.2918 34.285 15.0028V23.7548Z"
      fill="url(#paint0_linear_818_509)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_818_509"
        x1="24"
        y1="40.3058"
        x2="24"
        y2="7.69385"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.5" />
        <stop offset="0.001" stopColor="white" stopOpacity="0.502" />
        <stop offset="0.149" stopColor="white" stopOpacity="0.654" />
        <stop offset="0.3" stopColor="white" stopOpacity="0.778" />
        <stop offset="0.458" stopColor="white" stopOpacity="0.876" />
        <stop offset="0.622" stopColor="white" stopOpacity="0.945" />
        <stop offset="0.796" stopColor="white" stopOpacity="0.987" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
    </defs>
  </svg>
);
